import React from "react";
import { Select, Table, Tag } from "antd";
import { Link } from "lucide-react";
import PlusMinQty from "../../../utilities/PlusMinQty";

const { Option } = Select;

const LinkBrokers = ({ 
  brokers, 
  selectedBrokers, 
  onChange, 
  getBrokerLabel,
  title,
  hideHeader
}) => {
  const currentBrokerIds = (selectedBrokers || []).map(b => b.id);

  const handleSelect = (selectedId) => {
    const existing = (selectedBrokers || []).find(b => b.id === selectedId);
    if (!existing) {
      const newBrokers = [...(selectedBrokers || []), { id: selectedId, multiplier: 1 }];
      onChange(newBrokers);
    }
  };

  const handleChange = (selectedIds) => {
    const newBrokers = selectedIds.map(id => {
      const existing = (selectedBrokers || []).find(b => b.id === id);
      return existing || { id, multiplier: 1 };
    });
    onChange(newBrokers);
  };

  const handleDeselect = (removedId) => {
    const newBrokers = (selectedBrokers || []).filter(b => b.id !== removedId);
    onChange(newBrokers);
  };

  const updateMultiplier = (brokerId, newMultiplier) => {
    const parsedMultiplier = parseFloat(newMultiplier) || 1;
    const updatedBrokers = (selectedBrokers || []).map(b =>
      b.id === brokerId ? { ...b, multiplier: parsedMultiplier } : b
    );
    onChange(updatedBrokers);
  };

  const content = (
    <div className="link-brokers-content">
      <Table
        dataSource={[{ key: '1' }]}
        pagination={false}
        size="small"
        scroll={{ x: false }}
        style={{ maxWidth: '650px' }}
        columns={[
          {
            title: 'Select Brokers',
            key: 'brokers',
            width: '50%',
            render: () => (
              <Select
                mode="multiple"
                placeholder="Select brokers"
                style={{ width: '100%' }}
                value={currentBrokerIds}
                onSelect={handleSelect}
                onChange={handleChange}
                onDeselect={handleDeselect}
                tagRender={(props) => {
                  const { value, closable, onClose } = props;
                  const brokerLabel = getBrokerLabel(value);
                  return (
                    <Tag
                      className="link-broker-tag"
                      closable={closable}
                      onClose={onClose}
                      style={{ marginRight: 3, marginTop: 2, marginBottom: 2 }}
                    >
                      {brokerLabel}
                    </Tag>
                  );
                }}
              >
                {(brokers || []).map((b) => {
                  const id = b?.id;
                  const label = getBrokerLabel(id);
                  return (
                    <Option key={id} value={id}>{label}</Option>
                  );
                })}
              </Select>
            )
          },
          {
            title: 'Multiplier',
            align: 'center',
            key: 'multiplier',
            width: '50%',
            render: () => (
              <div className="multiplier-container">
                {(selectedBrokers || []).map((broker) => {
                  const label = getBrokerLabel(broker.id);
                  return (
                    <div key={broker.id} className="multiplier-row" style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                      <span className="multiplier-label" style={{ fontWeight: 500, marginRight: '10px' }}>{label}:</span>
                      <PlusMinQty
                        filterValue={broker.multiplier}
                        qtyClick={(newVal) => updateMultiplier(broker.id, newVal)}
                        min={1}
                        step={1}
                        name="multiplier"
                      />
                    </div>
                  );
                })}
              </div>
            )
          }
        ]}
      />
    </div>
  );

  if (hideHeader) return content;

  return (
    <div className="config-section" style={{ marginTop: '1rem' }}>
      <div className="qt-algo-section-header">
        <Link size={20} />
        <h3>{title || "Link Brokers"}</h3>
      </div>
      {content}
    </div>
  );
};

export default LinkBrokers;
